import ActionButton from "@/components/Button/ActionButton";
import { HStack } from "@/components/Layout";
import { LabelDevice } from "@/features/device/components/LabelDevice/LabelDevice";

import type { DeviceOption } from "./-types";

const DeviceMultiSelectOptionChip = (props: {
  option: DeviceOption;
  onRemove: () => void;
  disabled?: boolean;
}) => {
  const { option, onRemove, disabled = false } = props;

  return (
    <div className="flex items-center gap-1 rounded-md border border-neutral-border py-0.5 pl-2.5 pr-2">
      <HStack className="items-center gap-1.5 py-2">
        <LabelDevice
          name={option.label}
          avatarUrl={option.avatarUrl}
          genre={option.genre}
        />
      </HStack>
      <ActionButton
        onClick={onRemove}
        icon="XIcon"
        iconColor="active"
        variant="ghost"
        className="size-fit p-0"
        disabled={disabled}
      />
    </div>
  );
};

export default DeviceMultiSelectOptionChip;
